// Shared stepper labels for the multi-step Access and Guarding request forms.
// Centralised here so the standard and retail orderings stay in sync across
// every step page (previously each page redeclared its own copy, which drifted).
//
// Retail sites reorder Job Details to after Visitors, so retail has its own
// label order. Keep these arrays in step with the per-form navigation logic.

export const ACCESS_STEPPER_LABELS: string[] = ['Job Details', 'Select Date', 'Add Visitor', 'Access Type', 'Review'];
// Retail skips the "Access Type" step entirely, so its chain is
// Select Date -> Add Visitor -> Job Details -> Review.
export const ACCESS_STEPPER_LABELS_RETAIL: string[] = ['Select Date', 'Add Visitor', 'Job Details', 'Review'];

export const GUARDING_STEPPER_LABELS: string[] = ['Job Details', 'Select Date', 'Add Visitor', 'Review'];
export const GUARDING_STEPPER_LABELS_RETAIL: string[] = ['Select Date', 'Add Visitor', 'Job Details', 'Review'];
